import axios from 'axios';
import { ACCESS_TOKEN_KEY, getAccessToken, removeCookie } from '../storage/cookies';
// import { isExpiredAuth, refreshAccessToken } from '../auth';

const baseUrl = process.env.API_BASE_URL;

const client = axios.create({
  baseURL: baseUrl,
});

client.interceptors.request.use(
  async config => {
    if ((config.url?.indexOf('auth/login') || -1) > -1) {
      config.retry = true;
      return config;
    }
    // if ((config.url?.indexOf('auth/refresh_access_token') || -1) > -1) {
    //   return config;
    // }
    const token = getAccessToken().access;

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  async error => await Promise.reject(error),
);

client.interceptors.response.use(
  async response => {
    if ((response.config.url || '').indexOf('auth/login') > -1) {
      return response;
    }

    if (((response.config.url || '').indexOf('account_information') || -1) > -1) {
      return response;
    }

    // if (response.config.retry) {
    //   return response;
    // }

    // const token = getAccessToken();
    // if (!token) {
    //   return response;
    // }
    // if (((response.config.url || '').indexOf('refresh_access_token') || 1) < 0) {
    //   await refreshAccessToken();
    // }

    return response;
  },
  async error => {
    if (error.response?.status === 400 || error.response?.status === 401 || error.response?.status === 419) {
      removeCookie(ACCESS_TOKEN_KEY);
      window.location = '/signin';
    }
    // if ((error.config.url || '').indexOf('auth/login') > -1) {
    //   return Promise.reject(error);
    // }
    // if ((error.config.url || '').indexOf('refresh_access_token') > -1) {
    //   return Promise.reject(error);
    // }
    // if (error.response?.status === 401) {
    //   if (error.config.retry) {
    //     return Promise.reject(error);
    //   }
    //   if (await isExpiredAuth()) {
    //     return Promise.reject(error);
    //   }
    //   const token = getAccessToken();
    //   error.config.headers.Authorization = `Bearer ${token}`;
    //   error.config.retry = true;
    //   const response = await axios.request(error.config);
    //   return response;
    // }
    return Promise.reject(error);
  },
);

export default client;
